module.exports = __webpack_public_path__ + "media/images/logo_coorum-da96df6687dc14f5c1951ffb2d434ee2.svg";